import React from 'react';
import { CircularProgress, Box } from '@mui/material';
import MuscleHeadTextIcon from '../../../assets/MuscleHeadTextIcon';

import { useTheme } from '@mui/material/styles';

const LoadingPage = () => {
    const theme = useTheme();
    return (
        <Box
            display="flex"
            flexDirection={"column"}
            justifyContent="center"
            alignItems="center"
            height="100vh"
        >
            <MuscleHeadTextIcon sx={{
                height: {
                    xs:"6rem",
                    md:"10rem"
                },
                width: "100%",
                mb: 2    

            }} />
            <CircularProgress size="3rem" color={theme.palette.primary.main}/>
        </Box>
    );
};

export default LoadingPage;